(function (global) {

  /**
  * Коллекция элементов.  
  * @class WebAccess.Collection
  * @param {object} elements Элементы коллекции.
  * @since 5.0.0.7100
  */
  var Collection = Class.extend({
    className: "Collection",

    /**
    * Массив элементов.
    * @since 5.0.0.7100
    * @private
    */
    _arr: [],

    /**
    * Конструктор.
    * @since 5.0.0.7100
    * @private
    */
    init: function (elements) {
      this._arr = [];
      for (var name in elements) {
        this.addElement(name, elements[name]);
      }
    },

    /**
    * Добавляет новый элемент в коллекцию.
    * @method WebAccess.Collection#addElement
    * @param {string} name Название элемента коллекции.
    * @param {object} data Данные элемента коллекции.
    * @return {WebAccess.Collection}
    * @since 5.0.0.7100
    */
    addElement: function (name, data) {      
      this[name] = data;
      if (!$.isFunction(data)) this._arr.push(data);
      return this;
    },

    /**
    * Удаляет элемент из коллекции.
    * @method WebAccess.Collection#deleteElement
    * @param {string} name Название элемента коллекции.
    * @return {object} Удаленный элемент.
    * @since 5.0.0.7100
    */
    deleteElement: function (name) {
      var me = this;
      var deletedElement = null;
      if (me[name]) {
        deletedElement = me[name];
        delete me[name];

        for (var i = 0; i < me._arr.length; i++) {
          if (me._arr[i] === deletedElement) {
            me._arr.splice(i, 1);
            break;
          }
        }
      }
      return deletedElement;
    },

    /**
    * Очищает коллекцию.
    * @method WebAccess.Collection#clear
    * @return {WebAccess.Collection}
    */
    clear: function () {
      var me = this;
      for (var name in me) {
        if ($.inArray(me[name], me._arr) !== -1) {
          delete me[name];
        }
      }
      this._arr = [];
      return this;
    },

    /**
    * Кол-во элементов коллекции
    * @method WebAccess.Collection#count
    * @return {integer}
    */
    count: function () {
      return this._arr.length;
    },

    /**
    * Проверяет наличие элемента в коллекции по имени.
    * @method WebAccess.Collection#isExist
    * @param {string} name Название элемента коллекции.
    * @return {Boolean}
    */
    isExist: function (name) {
      return !!this[name];
    },

    /**
    * Возвращает элементы коллекции в виде массива.
    * @method WebAccess.Collection#toArray
    * @return {Array}
    */
    toArray: function () {
      return this._arr;
    }

  });

  global.Collection = Collection;

})(window.WebAccess);